import Choices from "choices.js";
import "choices.js/public/assets/styles/choices.min.css";

export function initChoices(): void {
    const selects = document.querySelectorAll<HTMLSelectElement>(
        'select[data-choices]'
    );

    selects.forEach((select) => {
        // prevent double init
        if (select.dataset.choicesInitialised === "1") return;
        select.dataset.choicesInitialised = "1";

        new Choices(select, {
            searchEnabled: true,
            itemSelectText: "",
            shouldSort: true,
        });
    });
}
